function getPoint(node: HTMLElement, x: number, y: number): [number, number] {
  const rect = node.getBoundingClientRect();
  return [x - rect.left - node.clientLeft, y - rect.top - node.clientTop];
}

export default getPoint;
